import React from 'react';
import Referrals from '../organizer/Referrals';

const PlayerReferrals = () => {
  return <Referrals userType="player" />;
};

export default PlayerReferrals;